import { useState, useEffect } from "react";
import { SubmitButton } from "../../components/Input";
import { Link, useNavigate, useParams } from "react-router-dom";
import { API_URL } from "../../config";
import axios from "axios";
import { showToast } from "../../components/toast";
import LoadingSpinner from "../../components/LoadingSpinner";

const ESIManagementForm = () => {
  const [formData, setFormData] = useState({
    user_fullname: "",
    esinumber: "",
    uan_number: "",
    esiImage: null,
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const token = localStorage.getItem("authToken");
  const { id } = useParams();
  const navigate = useNavigate();

  const fetchESIManagement = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}EsiMangement/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      setFormData(response.data.data); // Adjust this path if the API structure differs
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetchESIManagement();
    }
  }, [id]);

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handle file uploads
// Handle file uploads with validation
const handleFileChange = (e) => {
  const { name, files } = e.target;
  const file = files[0];

  if (file) {
    const validImageTypes = ["image/jpeg", "image/png", "image/jpg", "image/gif"];
    if (!validImageTypes.includes(file.type)) {
      showToast.error("Please select a valid image file (JPG, JPEG, PNG, GIF)");
      e.target.value = ""; // Reset the file input
      return;
    }
    setFormData((prev) => ({
      ...prev,
      [name]: file,
    }));
  }
};


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const formDataPayload = new FormData();
    formDataPayload.append("esinumber", formData.esinumber);
    formDataPayload.append("uan_number", formData.uan_number);
    formDataPayload.append("esi_image", formData.esiImage); // This should be a File object (e.g., from an <input type="file">)

    try {
      const response = await axios.put(
        `${API_URL}EsiMangement/update/${id}`,
        formDataPayload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.success === true) {
        showToast.success(response.data.message);
        navigate("/Hrms/EsiManagement");
      } else {
        showToast.error(response.data.message);
      }
    } catch (error) {
      showToast.error("An error occurred. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      id="page-container"
      className="page-header-fixed page-sidebar-fixed fade in"
    >
      <div id="content">
        {loading && <LoadingSpinner />}
        <div className="panel panel-default with-rounded-corner with-shadow mt-3">
          <form>
            <div className="panel-heading border-0 mb-1">
              <span className="panel-title">Edit User</span>
            </div>
            <div className="panel-body">
              <div className="row">
                {/* Reuse the InputBox, TextAreaField, and FileUpload components */}
                <div className="col-md-4 mb-2">
                  <label className="control-label">User Full Name</label>
                  <input
                    type="text"
                    onChange={handleChange}
                    name="user_fullname"
                    placeholder="Enter User Full Name"
                    className="form-control"
                    value={formData.user_fullname}
                    disabled={true}
                  />
                </div>
                <div className="col-md-4 mb-2">
                  <label className="control-label">ESI Number</label>
                  <input
                    type="text"
                    className="form-control"
                    name="esinumber"
                    value={formData.esinumber}
                    onChange={handleChange}
                    placeholder="Enter ESI Number"
                  />
                </div>
                <div className="col-md-4 mb-2">
                  <label className="control-label">UAN Number</label>
                  <input
                    type="text"
                    className="form-control"
                    name="uan_number"
                    value={formData.uan_number}
                    onChange={handleChange}
                    placeholder="Enter UAN Number"
                  />
                </div>
                {/* File Uploads */}
                <div className="col-md-4 mb-2">
                  <label className="control-label">ESI Image</label>
                  <input
                    type="file"
                    className="form-control"
                    name="esiImage"
                    onChange={handleFileChange}
                  />
                </div>
              </div>

              <div className="clearfix"></div>
              <SubmitButton
                pageBack="/Hrms/EsiManagement"
                handleSubmit={handleSubmit}
              />
            </div>
          </form>
        </div>

        {/* Scroll to Top Button */}
        <Link to="#" data-click="scroll-top" className="btn-scroll-top fade">
          <i className="ti-arrow-up"></i>
        </Link>
      </div>
    </div>
  );
};

export default ESIManagementForm;
